import { AxiosError } from 'axios';
import { logger } from '@fiverr-private/obs';

export const logError = (error: AxiosError, message = '') => {
    if (!error?.response?.status || error.response.status >= 500) return logger.error(error, { description: message });

    return logger.warn(error, { description: message });
};
